import { ConsoleFacade } from '@/shared/helpers/console-facade';
import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import tinyMce, { Editor, RawEditorOptions } from 'tinymce';

interface IViewModel {
    isInitialized: boolean;
}

@Component({
    components: {
    }
})
export default class HtmlEditorComponent extends Vue {

    @Prop({default: undefined}) public value!: string | undefined;
    @Prop({default: false}) public disabled!: boolean;
    @Prop({default: ''}) public contentClassName: string = '';
    @Prop({default: undefined}) public textareaId: string | undefined;
    @Prop({default: undefined}) public textareaName: string | undefined;
    @Prop({default: 'undo redo | bold italic | bullist numlist'}) public toolbar!: string;
    @Prop({default: undefined}) public height?: number | string;

    @Emit('input')
    // tslint:disable-next-line:no-empty
    public emitChange(content: string): string {

        return content;
    }

    public viewModel: IViewModel = {

        isInitialized: false
    }

    $refs!: {
        editor: HTMLInputElement
    }

    public get elementId(): string {

        return this.textareaId || `html-editor-${Date.now()}`;
    }

    public get elementName(): string {

        return this.textareaName || `html-editor-${Date.now()}`;
    }

    public get _element(): HTMLInputElement {

        return this.$refs.editor;
    }

    public mounted(): void {

        setTimeout(() => {
            this.initializeEditor();
        }, 100);
    }

    private get editorOptions(): RawEditorOptions {

        return {
            toolbar: this.toolbar,
            toolbar_mode: 'wrap',
            skin: 'tinymce-5',
            icons: 'default',
            convert_urls: false,
            height: this.height,
            style_formats: [
                { title: 'Heading 1', format: 'h1' },
                { title: 'Heading 2', format: 'h2' },
                { title: 'Heading 3', format: 'h3' },
                { title: 'Paragraph', format: 'p' }
            ],
            plugins: 'lists code link',
            selector: undefined,
            deprecation_warnings: false,
            target: this._element,
            readonly: this.disabled,
            menubar: false,
            body_class: this.contentClassName || undefined,
            setup: (editor: Editor) => {

                editor.on('init', (e: any) => {
                    editor.setContent(this.value || '');
                });

                editor.on('change input undo redo', (e: any) => {

                    let content = editor.getContent();

                    const pattern = /<p>&nbsp;<\/p>$/m;

                    content = content.replace(pattern, '');

                    this.emitChange(content);
                });
            }
        };
    }

    private initializeEditor(): void  {

        ConsoleFacade.log(`HtmlEditorComponent: Initializing html-editor`, this._element, this.editorOptions);

        const em = tinyMce.EditorManager;

        if (process.env.NODE_ENV === 'production') {
            em.baseURL = '/ui/dist/tinymce';
        } else {
            em.baseURL = '//localhost:8080/tinymce';
        }

        const editor = new tinyMce.Editor(
            this._element.id,
            this.editorOptions,
            em
        );

        editor.render();

        this.viewModel.isInitialized = true;
    }
}
